module.exports = __webpack_public_path__ + "img/208.3a0f8618.jpg";